
/*  Index-feature-product-new */
document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.feature-product-swiper', {
    slidesPerView: 1.218,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 3.218,
        spaceBetween: 0
      },
      991: {
        slidesPerView: 4,
        spaceBetween: 0
      }
    }
  });
});